module.exports = __webpack_public_path__ + "img/0922_cover.e2ef2a4d.jpg";